import { Outlet } from 'react-router-dom';
import { MainLayout } from '@/widgets';

export const AppLayout = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};
